// @story: none
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastContainerComponent } from '@zag/ui';

@Component({
  selector: 'ctrl-minimal-layout',
  imports: [RouterModule, ToastContainerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="minimal-layout">
      <div class="minimal-layout__content">
        <router-outlet />
      </div>

      <zag-toast-container />
    </div>
  `,
  styles: [
    `
      .minimal-layout {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        min-height: 100svh;
        background: var(--background-color-secondary);
      }

      .minimal-layout__content {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: var(--spacing-lg, 24px);
      }
    `,
  ],
})
export class MinimalLayoutComponent {}
